import request from "./client";

export const getWhitelabel = async (token) => {
  try {
    const resp = await request.get(`/v1/settings/whitelabeling`);
    const body = resp.body;
    return { data: body, error: null };
  } catch (e) {
    if (!e.response) {
      return { data: null, error: e };
    }
    return { data: null, error: e.response.body };
  }
};

export const getTranslation = async (token) => {
  try {
    const resp = await request.get(`/v1/settings/translation`);
    const body = resp.body;
    return { data: body, error: null };
  } catch (e) {
    if (!e.response) {
      return { data: null, error: e };
    }
    return { data: null, error: e.response.body };
  }
};

export const updateTranslationOverrides = async (payload) => {
  try {
    const resp = await request.put(`/v1/settings/translation`).send(payload);
    return { data: resp.body, error: null };
  } catch (e) {
    if (!e.response) {
      return { data: null, error: e };
    }
    return { data: null, error: e.response.body };
  }
};

export const getFeatures = async () => {
  try {
    const resp = await request.get(`/v1/settings/features`);
    return { data: resp.body, error: null };
  } catch (e) {
    if (!e.response) {
      return { data: null, error: e };
    }
    return { data: null, error: e.response.body };
  }
};

export const getNatrav = async () => {
  try {
    const resp = await request.get(`/v1/settings/natrav`);
    return { data: resp.body, error: null };
  } catch (e) {
    if (!e.response) {
      return { data: null, error: e };
    }
    return { data: null, error: e.response.body };
  }
};

export const getSqlbase = async () => {
  try {
    const resp = await request.get(`/v1/settings/sqlbase`);
    return { data: resp.body, error: null };
  } catch (e) {
    if (!e.response) {
      return { data: null, error: e };
    }
    return { data: null, error: e.response.body };
  }
};

export const updateSqlbase = async (payload) => {
  try {
    const resp = await request.put(`/v1/settings/sqlbase`).send(payload);
    return { data: resp.body, error: null };
  } catch (e) {
    if (!e.response) {
      return { data: null, error: e };
    }
    return { data: null, error: e.response.body };
  }
};

export const checkSqlbase = async (payload) => {
  try {
    const resp = await request.post("/v1/settings/sqlbase/check").send(payload);
    return { data: resp.body, error: null };
  } catch (e) {
    if (!e.response) return { data: null, error: e };
    return { data: null, error: e.response.body };
  }
};

export const getSqlbaseAuthorization = async () => {
  try {
    const resp = await request.get("/v1/settings/sqlbase/authorization");
    return { data: resp.body, error: null };
  } catch (e) {
    if (!e.response) return { data: null, error: e };
    return { data: null, error: e.response.body };
  }
};

export const acceptSqlbaseAuthorization = async ({ dbName } = {}) => {
  const version = process.env.REACT_APP_GIT_VERSION || "dev";
  try {
    const resp = await request
      .post("/v1/settings/sqlbase/authorization")
      .send({ version, db_name: dbName || "" });
    return { data: resp.body, error: null };
  } catch (e) {
    if (!e.response) return { data: null, error: e };
    return { data: null, error: e.response.body };
  }
};

export const checkTunnel = async () => {
  try {
    const resp = await request.get("/v1/erp/sqlbase/tunnel/check");
    return { data: resp.body, error: null };
  } catch (e) {
    if (!e.response) return { data: null, error: e };
    return { data: null, error: e.response.body };
  }
};

export const getEnv = async (token) => {
  try {
    const resp = await request.get(`/v1/settings/env`);
    const body = resp.body;
    return { data: body, error: null };
  } catch (e) {
    if (!e.response) {
      return { data: null, error: e };
    }
    return { data: null, error: e.response.body };
  }
};
